module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ChartBar1":"hello world!"},"de":{"ChartBar1":"ChartBarenen"}}')
  delete Component.options._Ctor
}
